var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('horizontal-nav',{staticClass:"p-t-10 p-b-10",attrs:{"items":_vm.items,"set_view":true,"show_display":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }